var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35,
    stroke: "#84DCC8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6654 36.0026C52.6654 45.2073 45.2034 52.6693 35.9987 52.6693C26.794 52.6693 19.332 45.2073 19.332 36.0026C19.332 26.7979 26.794 19.3359 35.9987 19.3359C45.2034 19.3359 52.6654 26.7979 52.6654 36.0026Z",
    fill: "#84DCC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7185 30.9521C43.2067 31.4402 43.2067 32.2317 42.7185 32.7198L34.3852 41.0532C33.897 41.5413 33.1056 41.5413 32.6174 41.0532L29.2841 37.7198C28.7959 37.2317 28.7959 36.4402 29.2841 35.9521C29.7722 35.4639 30.5637 35.4639 31.0519 35.9521L33.5013 38.4015L37.226 34.6768L40.9508 30.9521C41.4389 30.4639 42.2304 30.4639 42.7185 30.9521Z",
    fill: "#1177BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.949ff38109358e48d57a15cb599b40ea.svg";
export { ForwardRef as ReactComponent };